import React, { useEffect, useState } from 'react'

// import axios from 'axios'

import logo from '../Assets/Kabakoo.png'

import './style.css'
import { getLocalStorageData, handleDataStructure } from '../config/helpers'
import CountdownTimer from '../config/Timer'

function Oups({ componentDidMount }) {

    const [help, setHelp] = useState(false)
    const [timer, setTimer] = useState({ 'is': true, 'time': '2023-09-01T17:57:30.973Z' })


    let storeData = getLocalStorageData()
    useEffect(() => {
        // handleDataStructure("time", '2023-11-09T12:37:01.973Z');


        setHelp(storeData.kaba_info.help)
        let local_data_time = storeData.kaba_info.time
        local_data_time ? setTimer({ ...timer, 'time': local_data_time }) : ''

    }, [help,timer])

    return (
        <div>
            {
                help ? <div className='heading'>
                    <div className="logo">
                        <div className="image">
                            <img src={logo} alt="logo" />
                        </div>
                    </div>
                    <div className="title">
                        <h3>Ta requête à été envoyée avec succès ! <br /> Tu seras contacter dans de bref délais.</h3>
                    </div>
                        <CountdownTimer stopTimer={setTimer} timer={timer} />
                </div>
                    :
                    <div className='heading'>
                        <div className="logo">
                            <div className="image">
                                <img src={logo} alt="logo" />
                            </div>
                        </div>
                        <div className="title">
                            <h3>Oups ! <br />
                                Source non vérifiée.</h3>
                        </div>

                    </div>
            }

        </div>
    );
}


export default Oups